// extracted by mini-css-extract-plugin
export default {"p":"fa3cc6d213 _8b0e4e605e c46f260c01","clr":"_67369f8fda","dls":"_13b50fe937"};